"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const liveChatInputs = [
  {
    name: "enabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "configuration",
    type: "object",
    required: true,
    defaultValue: {},
    showIf: `options.get("enabled") === true`,
    subFields: [
      {
        name: "scriptSrc",
        type: "string",
        required: true,
      },
      {
        name: "moduleId",
        type: "string",
        required: true,
      },
      {
        name: "languageCode",
        type: "string",
        required: true,
      },
    ],
  },
] as const satisfies Inputs;

export const LiveChatComponent: RegisteredComponent = {
  name: "LiveChat",
  models: [getBuilderModelName("live-chat")],
  component: dynamic(async () => withValidation(liveChatInputs, (await import("./LiveChat")).LiveChat, "LiveChat"), {
    ssr: false,
  }),
  inputs: liveChatInputs,
};
